import { Box, Card, Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { ArtifactTemplate } from './artifactTemplatesData';
import { TruncatedTextTooltip } from '../../../common/TruncatedTextTooltip';
import { ClampedText } from '../../../common/ClampedText';

const CARD_HEIGHT = 136;

interface ArtifactTemplateCardProps {
  template: ArtifactTemplate;
  onClick: () => void;
}

export const ArtifactTemplateCard = ({ template, onClick }: ArtifactTemplateCardProps) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        boxShadow: 'none',
        transition: 'border-color 0.2s ease-in-out',
        height: `${CARD_HEIGHT}px`,
        p: 2,
        display: 'flex',
        gap: 2,
        '&:hover': {
          borderColor: colors.blue[500],
        },
      }}
    >
      {/* Image on the left */}
      <Box
        sx={{
          width: '104px',
          height: '104px',
          minWidth: '100px',
          backgroundColor: colors.grey[200],
          borderRadius: '8px',
        }}
      >
        {template.image ? (
          <img
            src={template.image}
            alt={template.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : null}
      </Box>

      <Stack sx={{ flex: 1, minWidth: 0, justifyContent: 'center', overflow: 'hidden' }}>
        <Box
          sx={{
            height: '20px',
            mb: 1,
            width: '100%',
            '& .MuiTypography-root': {
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        >
          <TruncatedTextTooltip variant="body-bold" color={colors.grey[900]}>
            {template.title}
          </TruncatedTextTooltip>
        </Box>

        <Box sx={{ height: '48px' }}>
          <ClampedText
            text={template.subtitle}
            typographyVariant="body"
            textColor={colors.grey[700]}
            lines={2}
          />
        </Box>
      </Stack>
    </Card>
  );
};
